module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idgenobjectstyleoverride",
    attrs: {
      "id": "_idContainer1347"
    }
  }, [_c('p', {
    staticClass: "structure-prep-infos",
    attrs: {
      "id": "calibre_pb_56"
    }
  }, [_vm._v("Prep Time: "), _c('span', {
    staticClass: "prep-time-blue"
  }, [_vm._v("5 minutes")]), _vm._v(" • Cooking Time: "), _c('span', {
    staticClass: "prep-time-blue"
  }, [_vm._v("20 minutes")]), _vm._v(" • Makes: "), _c('span', {
    staticClass: "prep-time-blue"
  }, [_vm._v("2 servings")])]), _vm._v(" "), _c('p', {
    staticClass: "icon"
  }, [_vm._v("KETO • paleo •"), _c('span', {
    staticClass: "bold6"
  }, [_c('img', {
    staticClass: "_idgenobjectattribute7",
    attrs: {
      "alt": "",
      "src": "OEBPS/image/no-glluten.png"
    }
  })]), _c('img', {
    staticClass: "_idgenobjectattribute7",
    attrs: {
      "alt": "",
      "src": "OEBPS/image/no-dairy.png"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "_idgenobjectattribute7",
    attrs: {
      "alt": "",
      "src": "OEBPS/image/no-nuts.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "body_heading-recipe"
  }, [_c('span', {
    staticClass: "heading-red"
  }, [_vm._v("Mini ")]), _vm._v("Meatball Breakfast Hash")]), _vm._v(" "), _c('ul', {
    staticClass: "calibre4"
  }, [_c('li', {
    staticClass: "body_ingredients"
  }, [_vm._v("8 ounces organic gro"), _c('span', [_vm._v("und")]), _c('span'), _c('span', [_vm._v("turkey")])]), _vm._v(" "), _c('li', {
    staticClass: "body_ingredients"
  }, [_vm._v("1 red bell pep"), _c('span', [_vm._v("per, diced")])]), _vm._v(" "), _c('li', {
    staticClass: "body_ingredients"
  }, [_vm._v("6 ounces ba"), _c('span', [_vm._v("by")]), _c('span'), _c('span', [_vm._v("spinach")])]), _vm._v(" "), _c('li', {
    staticClass: "body_ingredients"
  }, [_vm._v("2 pasture-raised & or"), _c('span', [_vm._v("ganic")]), _c('span'), _c('span', [_vm._v("eggs")])]), _vm._v(" "), _c('li', {
    staticClass: "body_ingredients"
  }, [_vm._v("1 pound of frozen & thawed caulif"), _c('span', [_vm._v("lower")]), _c('span'), _c('span', [_vm._v("rice")])])]), _vm._v(" "), _c('p', {
    staticClass: "body_youtube"
  }, [_c('img', {
    staticClass: "calibre3",
    attrs: {
      "alt": "",
      "src": "OEBPS/image/you-tube-black.png"
    }
  }), _vm._v("To watch the video tutorial for this recipe, search “FlavCity keto hash” on YouTube.")]), _vm._v(" "), _c('p', {
    staticClass: "shopping-tips-left-justified-1col1"
  }, [_c('img', {
    staticClass: "calibre3",
    attrs: {
      "alt": "",
      "src": "OEBPS/image/shopping-tip_white.png"
    }
  }), _vm._v("\tIt’s important that the "), _c('span', {
    staticClass: "shopping-tip-bold-red1"
  }, [_vm._v("turkey")]), _vm._v(" is organic. That means they have a non-GMO feed. "), _c('span', {
    staticClass: "shopping-tip-bold-red1"
  }, [_vm._v("Peppers")]), _vm._v(" and "), _c('span', {
    staticClass: "shopping-tip-bold-red1"
  }, [_vm._v("spinach")]), _vm._v(" are always on the dirty dozen, so I would also buy"), _c('span'), _vm._v("organic.")]), _vm._v(" "), _c('p', {
    staticClass: "shopping-tips-left-justified-1col1"
  }, [_c('span', {
    staticClass: "bold4"
  }), _c('span', {
    staticClass: "shopping-tip-bold-red1"
  }, [_c('img', {
    staticClass: "calibre3",
    attrs: {
      "alt": "",
      "src": "OEBPS/image/shopping-tip_white.png"
    }
  }), _vm._v(" Frozen cauliflower rice")]), _vm._v(" works best for this recipe as it’s too hard to squeeze the water from freshly grated rice. Costco has an incredible deal on a five-pound frozen bag! No need to buy organic because cauliflower is on the clean fifteen"), _c('span'), _vm._v("list.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-337f102e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/5Ingredient_split_034.vue
// module id = 159
// module chunks = 0